import * as React from 'react';
import { downloadBlob } from '@/utils/share';

/**
 * Manages a Blob's object URL lifecycle — creates on blob change, revokes on cleanup.
 * Returns the current object URL and a download trigger.
 */
export function useBlobUrl(blob: Blob | null | undefined, filename = 'decho-share.png') {
  const [url, setUrl] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!blob) {
      setUrl(null);
      return;
    }
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob]);

  const download = React.useCallback(() => {
    if (blob) downloadBlob(blob, filename);
  }, [blob, filename]);

  return { url, download };
}
